import React from 'react';
import { motion } from 'framer-motion';
interface PrimaryButtonProps {
  children: ReactNode;
  onClick: () => void;
  disabled?: boolean;
  className?: string;
  icon?: ReactNode;
}
export function PrimaryButton({
  children,
  onClick,
  disabled = false,
  className = '',
  icon
}: PrimaryButtonProps) {
  return <motion.button whileTap={disabled ? {} : {
    scale: 0.97
  }} onClick={onClick} disabled={disabled} className={`w-full min-h-[56px] rounded-lg font-bold text-lg flex items-center justify-center gap-2 transition-colors ${disabled ? 'bg-slate-800 text-slate-500 cursor-not-allowed' : 'bg-orange-500 hover:bg-orange-600 text-white shadow-lg shadow-orange-500/20'} ${className}`} data-id="element-1088">
      {icon}
      {children}
    </motion.button>;
}